import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=cddfd8f2&scoped=true&"
import script from "./comments.js?vue&type=script&lang=js&"
export * from "./comments.js?vue&type=script&lang=js&"
import style0 from "./comments.scss?vue&type=style&index=0&id=cddfd8f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddfd8f2",
  null
  
)

export default component.exports